import { render, staticRenderFns } from "./marKetingSet.vue?vue&type=template&id=028c782c&scoped=true&"
import script from "./marKetingSet.vue?vue&type=script&lang=js&"
export * from "./marKetingSet.vue?vue&type=script&lang=js&"
import style0 from "./marKetingSet.vue?vue&type=style&index=0&id=028c782c&scoped=true&lang=css&"
import style1 from "./marKetingSet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c782c",
  null
  
)

export default component.exports